var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'antd/lib/collapse';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Tag from 'antd/lib/tag';
var Panel = Collapse.Panel;
var CheckableTag = Tag.CheckableTag;
var EditorClassName = /** @class */ (function (_super) {
    __extends(EditorClassName, _super);
    function EditorClassName() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.onChange = function (value) {
            _this.props.onChange(value);
        };
        return _this;
    }
    EditorClassName.prototype.render = function () {
        var _this = this;
        var props = __rest(this.props, []);
        var value = props.value, classNameArray = props.classNameArray, editClassName = props.editClassName, locale = props.locale;
        ['value', 'onChange'].map(function (key) { return delete props[key]; });
        return (React.createElement(Panel, __assign({}, props, { header: props.header || locale.header }),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, null, locale.exclusive)),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, null,
                    React.createElement(CheckableTag, { key: editClassName, onChange: function () {
                            _this.onChange(editClassName);
                        }, checked: value === editClassName }, editClassName))),
            !!classNameArray.length && [
                (React.createElement(Row, { gutter: 8, key: "name" },
                    React.createElement(Col, { span: 24 }, locale.common))),
                (React.createElement(Row, { gutter: 8, key: "select" },
                    React.createElement(Col, { span: 18 }, classNameArray.map(function (key) {
                        return (React.createElement(CheckableTag, { key: key, onChange: function () {
                                _this.onChange(key);
                            }, checked: value === key }, key));
                    })))),
            ]));
    };
    EditorClassName.propTypes = {
        value: PropTypes.string,
        onChange: PropTypes.func,
        classNameArray: PropTypes.array,
        header: PropTypes.string,
        placeholder: PropTypes.string,
        locale: PropTypes.object,
    };
    EditorClassName.defaultProps = {
        value: '',
        onChange: function () {
        },
    };
    return EditorClassName;
}(Component));
export default EditorClassName;
EditorClassName.componentName = 'EditorClassName';
